"use client";

import type { DiscountType } from "@frontend/lib/graphql/generated-gql";
import { type ReactNode, createContext, useContext, useState } from "react";

export interface DiscountData {
  discountPercent: number;
  discountDollarAmount: number;
  discountType: DiscountType;
  code: string;
  isActive: boolean;
  appliesToHrts: number[];
}

interface DiscountCodeContextType {
  discountData: DiscountData | undefined;
  setDiscountData: (data: DiscountData | undefined) => void;
  isDiscountApplied: boolean;
  setIsDiscountApplied: (applied: boolean) => void;
}

const DiscountCodeContext = createContext<DiscountCodeContextType | undefined>(
  undefined,
);

export function DiscountCodeProvider({ children }: { children: ReactNode }) {
  const [discountData, setDiscountData] = useState<DiscountData | undefined>(
    undefined,
  );
  const [isDiscountApplied, setIsDiscountApplied] = useState(false);

  return (
    <DiscountCodeContext.Provider
      value={{
        discountData,
        setDiscountData,
        isDiscountApplied,
        setIsDiscountApplied,
      }}
    >
      {children}
    </DiscountCodeContext.Provider>
  );
}

export function useDiscountCode() {
  const context = useContext(DiscountCodeContext);
  if (context === undefined) {
    throw new Error(
      "useDiscountCode must be used within a DiscountCodeProvider",
    );
  }
  return context;
}
